import React from 'react'

import '../styles/words-svg.css'

const Words = () => (
   <svg className="words" viewBox="0 0 500 500">
      <defs>
         <pattern
            id="textPattern"
            x="0"
            y="0"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            patternUnits="userSpaceOnUse"
         >
            <circle cx="10" cy="10" r="0" />
         </pattern>
      </defs>

      <g className="words-group">
         <text className="text">
            build
         </text>

         <text dy="1em" className="text">
            like
         </text>

         <text dy="2em" className="text">
            beavers®
         </text>

         <text dy="3em" className="text">
            ltd
         </text>
      </g>
   </svg>
)

export default Words
